'use client';

import { Box, Button, Container, Typography } from '@mui/material';
import * as Sentry from '@sentry/nextjs';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFound() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    // Report 404 errors to Sentry
    Sentry.captureMessage(`404 Not Found: ${pathname}`, {
      level: 'warning',
      tags: {
        component: 'not-found',
        path: pathname,
        environment: process.env.NODE_ENV,
      },
    });
  }, [pathname]);

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        textAlign: 'center',
        py: 4,
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{ fontSize: 120, fontWeight: 'bold', color: 'primary.main' }}
      >
        404
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 3 }}>
        Page Not Found
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 500 }}
      >
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.push('/')}
        >
          Go Home
        </Button>

        <Button variant="outlined" onClick={() => router.back()}>
          Go Back
        </Button>
      </Box>
    </Container>
  );
}
